/* easify-price-sync.js
 * Adds the Easify Product Options add-on (e.g. Finger Size "P [ +£110.00 ]") to the displayed
 * product price, compare-at price and Add to cart button price on product pages.
 * Display only: cart/checkout pricing is still handled by Easify/Shopify as before.
 * Loaded from layout/theme.liquid on product templates only.
 * v2: also works when Easify renders without its app-block wrapper (.easify-product-options),
 * e.g. auto-injected straight into the product form (.tpo_option-set-wrapper inside
 * .product__submit__buttons) on templates that have no Easify app block.
 */
(function () {
  'use strict';
  var PRICE_SEL = '[data-price-wrapper] [data-product-price], [data-price-wrapper] [data-compare-price]';
  var BTN_SEL = '[data-product-form-outer] [data-button-price], [data-add-to-cart] [data-button-price]';
  var FMT = /^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/;

  function parseMoney(str) {
    var m = FMT.exec((str || '').replace(/\u00a0/g, ' ').trim());
    if (!m) return null;
    var digits = m[2].replace(/,/g, '');
    var dec = m[2].indexOf('.') > -1 ? m[2].split('.')[1].length : 0;
    return { prefix: m[1], suffix: m[3], value: parseFloat(digits), decimals: dec, symbol: m[1].trim() };
  }

  function formatMoney(parts, value) {
    var dec = parts.decimals;
    if (!dec && Math.abs(value - Math.round(value)) > 0.001) dec = 2;
    var fixed = value.toFixed(dec).split('.');
    fixed[0] = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.prefix + fixed.join('.') + parts.suffix;
  }

  var TOTAL_SEL = '.tpo_total-additional-price-input, input[name="tpo_total-additional-price"]';

  // Easify's container. Two layouts exist on this store:
  //  a) app block: .shopify-app-block > .easify-product-options > .tpo_option-set-wrapper
  //  b) no app block (auto-injected into the product form): .tpo_option-set-wrapper only
  // Prefer the one belonging to the main product form when there are several.
  function findRoot() {
    var cands = [];
    document.querySelectorAll('.easify-product-options, .tpo_option-set-wrapper').forEach(function (el) {
      // skip a .tpo_option-set-wrapper that is already inside an .easify-product-options candidate
      if (el.classList.contains('tpo_option-set-wrapper') && el.closest('.easify-product-options')) return;
      cands.push(el);
    });
    if (!cands.length) {
      var t = document.querySelector(TOTAL_SEL);
      if (t) cands.push(t.closest('form') || t.parentElement);
    }
    if (!cands.length) return null;
    var main = document.querySelector('main') || document.body;
    for (var i = 0; i < cands.length; i++) {
      if (main.contains(cands[i]) && cands[i].querySelector(TOTAL_SEL + ', .tpo_option-input')) return cands[i];
    }
    return cands[0];
  }

  // Add-on total (in major currency units) read from Easify's markup.
  function readAddon() {
    var wrap = findRoot();
    if (!wrap) return null;
    var total = wrap.querySelector(TOTAL_SEL);
    if (total && total.value) {
      var p = parseMoney(total.value);
      if (p) return { value: p.value, symbol: p.symbol };
    }
    // Fallback: sum "[ +£220.00 ]" fragments from selected option text/values
    var sum = 0, symbol = '', found = false;
    wrap.querySelectorAll('input.tpo_option-input, select, input[type=radio]:checked, input[type=checkbox]:checked').forEach(function (el) {
      var txt = el.value || '';
      var m = /\[\s*\+\s*([^\d\s]*)\s*([\d,]+(?:\.\d+)?)\s*\]/.exec(txt);
      if (m) { sum += parseFloat(m[2].replace(/,/g, '')); symbol = m[1]; found = true; }
    });
    return found ? { value: sum, symbol: symbol } : { value: 0, symbol: '' };
  }

  function qty() {
    var q = document.querySelector('[data-product-form-outer] input[name="quantity"], input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  var observer = null;
  var lastKey = '';

  // Never rewrite the theme's own price elements (the theme re-renders them on variant/quantity
  // change, and may re-render the same text). Instead show the total in a sibling span and hide
  // the original while an add-on is selected. The original always keeps the theme's base price.
  function apply(el, addon, multiplier) {
    var base = parseMoney(el.textContent);
    var sib = el.nextElementSibling && el.nextElementSibling.hasAttribute('data-ez-price') ? el.nextElementSibling : null;
    var add = 0;
    if (base && addon && addon.value > 0 && (!base.symbol || !addon.symbol || base.symbol === addon.symbol)) {
      add = addon.value * multiplier;
    }
    if (!add) {
      if (sib) sib.remove();
      if (el.hasAttribute('data-ez-hidden')) { el.style.display = ''; el.removeAttribute('data-ez-hidden'); }
      return;
    }
    var out = formatMoney(base, base.value + add);
    if (!sib) {
      sib = document.createElement('span');
      sib.setAttribute('data-ez-price', '');
      sib.className = el.className;
      el.insertAdjacentElement('afterend', sib);
    }
    if (sib.textContent !== out) sib.textContent = out;
    if (el.style.display !== 'none') { el.style.display = 'none'; el.setAttribute('data-ez-hidden', ''); }
  }

  function update() {
    var addon = readAddon();
    if (!addon) return;
    if (observer) observer.disconnect();
    try {
      document.querySelectorAll(PRICE_SEL).forEach(function (el) { apply(el, addon, 1); });
      document.querySelectorAll(BTN_SEL).forEach(function (el) { apply(el, addon, qty()); });
    } finally {
      watch();
    }
  }

  function watch() {
    if (!observer) observer = new MutationObserver(function () { schedule(); });
    var root = document.querySelector('main') || document.body;
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  var timer = null;
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; update(); }, 30); }

  document.addEventListener('click', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('input', schedule, true);
  // Easify sets its hidden total input programmatically (no DOM event), so also poll cheaply.
  setInterval(function () {
    var a = readAddon();
    var key = a ? a.value + '|' + qty() : '';
    if (key !== lastKey) { lastKey = key; update(); }
  }, 250);
  watch();
  schedule();
})();
